import { Grid } from "@mui/material";
import Libelle from "../../_i18n/fr.json";
import Layout from "../../components/Layout";
import AjouterMessages from "./AjouterMessages";
import TableauMessages from "./TableauMessages";

function MessagesPage() {
  return (
    <Layout title={Libelle.pageMessages.titre}>
      <Grid container>
        <AjouterMessages />
        <TableauMessages />
      </Grid>
    </Layout>
  );
}

export default MessagesPage;
